import React from "react";
import { Row, Col } from "react-bootstrap";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import id from "@irati/utils/id";
import StyledDeal from "./styled/Deal";
import "./styles/DealList.css";
var DealList = function (props) {
    var deals = props.deals, page = props.page;
    var idNamespace = id("deal-list", props);
    return (React.createElement(Row, { id: idNamespace },
        React.createElement(TransitionGroup, null, deals.map(function (deal, index) { return (React.createElement(CSSTransition, { key: deal.uuid, classNames: "dealList", timeout: { enter: 400, exit: 300 } },
            React.createElement(Col, { id: id("column-" + index, idNamespace), md: 4, sm: 6, xs: 12 },
                React.createElement(StyledDeal, { id: id(deal.uuid, idNamespace), deal: deal, page: page })))); }))));
};
export default DealList;
